import Immigration from "./Immigration";

const components = {
    Immigration,
    Taxes: undefined,
    Crime: undefined,
    Injury: undefined,
    Family: undefined
};

export const getAdvancedFiltersComponent = (formName) => components[formName];

export default components;